import { createContext } from 'react';
const AsyncComponentContext = /*#__PURE__*/createContext({});
export default AsyncComponentContext;